"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vuse = void 0;
var Alto2_1 = require("./Alto2");
var SmartBox_1 = require("./SmartBox");
var ePod_1 = require("./ePod");
var ePod2_1 = require("./ePod2");
var ePod3_1 = require("./ePod3");
var VuseDevice = /** @class */ (function () {
    function VuseDevice() {
        this.setDevice = function (device) {
            switch (device) {
                case 'ePod':
                    return new ePod_1.ePodDevice();
                // case 'vSeries':
                //   return new vSeriesDevice();
                case 'ePod2':
                    return new ePod2_1.ePod2Device();
                case 'ePod3':
                    return new ePod3_1.ePod3Device();
                case 'Alto2':
                    return new Alto2_1.Alto2Device();
                case 'SmartBox':
                    return new SmartBox_1.SmartBoxDevice();
                default:
                    throw new Error('VuseDevice: unexisting device type!');
            }
        };
    }
    return VuseDevice;
}());
exports.vuse = new VuseDevice();
